<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <SharedWindow
    :class="b()"
    title="Подтверждение обмена через email"
    @close="handleClose"
  >
    <div :class="b('wrapper')">
      <p :class="b('label')">
        {{ $t("Код-подтверждение отправлен на email") }}
      </p>

      <div :class="b('form')">
        <SharedVerification
          :class="b('verification')"
          v-model:code="code"
          :is-error="isIncorrectCode"
        />
      </div>

      <UIButton
        label="Обмен"
        view="main"
        :disabled="isCreateDisabled"
        @click="handleCreate"
      />
    </div>
  </SharedWindow>
</template>
